import { fetchRequestSearch, fetchReport } from '../../../services/api/request';
import { naturalCompare } from '../../../helpers';
import { request } from 'https';

function getRequestValue(request, key) {
    switch (key) {
        case 'isJuridical':
        case 'subjectType':
            return request.isJuridical ? 'Юр. лицо' : 'Физ. лицо';
        default:
            return request[key];
    }
}

export const requests = {
    namespaced: true,
    state: {
        search: '',
        display: 10,
        page: 1,
        sort: {
            column: 'datetime',
            order: 'desc',
        },
        requests: [],
        count: 0,
        pending: false
    },
    mutations: {
        saveRequest(state, data) {
            state.requests = data.requests;
            state.count = data.count;
        },
        setPage(state, page) {
            state.page = page;
        },
        setSort(state, sort) {
            state.sort = sort;
        },
        search(state, search) {
            state.search = search || '';
        },
        setPending(state, bool) {
            state.pending = bool
        },
        resetState(state) {
            state.page = 1;
            state.search = '';
            state.requests = [];
        }
    },
    actions: {
        fetchRequestSearch({ commit, dispatch }) {
            commit('setPending', true)
            return fetchRequestSearch()
                .then((res) => {
                    commit('saveRequest', res.data);
                    commit('setPending', false)
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });
                    commit('setPending', false)
                    throw res;
                });
        },
        fetchIntervalRequestSearch({ commit, dispatch }) {
            return fetchRequestSearch()
                .then((res) => {
                    commit('saveRequest', res.data);
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });
                    throw res;
                });
        },
        fetchReport({ dispatch }, link) {
            return fetchReport(link)
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
        setPage({ commit, dispatch, state }, page) {
            commit('setPage', page);
            commit('setPending', true)
            return fetchRequestSearch(state.search, (page - 1) * 10)
                .then((res) => {
                    commit('saveRequest', res.data);
                    commit('setPending', false)
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });
                    commit('setPending', false)
                    throw res;
                });
        },
        setSort({ commit }, sort) {
            commit('setSort', sort);
        },
        search({ commit, dispatch }, search) {
            commit('setPending', true)
            commit('search', search);
            commit('setPage', 1);
            return fetchRequestSearch(search)
                .then((res) => {
                    commit('saveRequest', res.data);
                    commit('setPending', false)
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });
                    commit('setPending', false)
                    throw res;
                });
        },
        resetState({ commit }) {
            commit('resetState');
        }
    },
    getters: {
        totalRecords({ count }) {
            return count;
        },
        sortedRecords({ sort, requests }) {
            const sorted = requests.sort((a, b) => {
                return naturalCompare(
                    getRequestValue(a, sort.column),
                    getRequestValue(b, sort.column));
            });

            return sort.order === 'asc'
                ? sorted
                : sorted.reverse();
        },
        paginatedRecords({ page }, { sortedRecords }) {
            return sortedRecords
        },
    }
};


// WEBPACK FOOTER //
// ./src/modules/home/requests/store.js